import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { DS } from '../../PatientForms/designTokens';
import { OtherMedication } from '../types';

interface MultipleOtherMedicationsProps {
  otherMedications: OtherMedication[];
  setOtherMedications: (medications: OtherMedication[]) => void;
  handleFormSubmit: (e: React.FormEvent) => void;
}

const MultipleOtherMedications: React.FC<MultipleOtherMedicationsProps> = ({
  otherMedications,
  setOtherMedications,
  handleFormSubmit,
}) => {
  const [addMoreMode, setAddMoreMode] = useState<null | boolean>(null);

  const handleInputChange = (index: number, value: string) => {
    const updated = [...otherMedications];
    updated[index].name = value;
    setOtherMedications(updated);
  };

  const handleAddNewSet = () => {
    const last = otherMedications[otherMedications.length - 1];
    if (last && !last.name) return;

    setOtherMedications([...otherMedications, { name: '' }]);
  };

  const handleAddMoreRadioChange = (value: 'Ja' | 'Nej') => {
    if (value === 'Ja') {
      handleAddNewSet();
      setAddMoreMode(true);
    } else {
      setAddMoreMode(false);

      setOtherMedications(otherMedications.slice(0, 1));
    }
    setShouldSubmit(true);
  };

  const [shouldSubmit, setShouldSubmit] = useState(false);

  useEffect(() => {
    if (shouldSubmit) {
      handleFormSubmit(new Event('submit') as unknown as React.FormEvent);
      setShouldSubmit(false);
    }
  }, [shouldSubmit, otherMedications, handleFormSubmit]);
  useEffect(() => {
    if (otherMedications.length > 1 && addMoreMode !== true) {
      setAddMoreMode(true);
    }
  }, [otherMedications, addMoreMode]);

  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      {otherMedications.map((med, index) => (
        // eslint-disable-next-line react/no-array-index-key -- entries have no id; the list is only appended to, edited in place or truncated from the end
        <Box key={index}>
          <Typography
            sx={{
              display: 'block',
              color: '#374151',
              mb: 1,
              fontFamily: DS.fontBody,
              fontSize: '16px',
            }}
          >
            Preparat? Dos? Syfte?
          </Typography>
          <input
            type="text"
            onBlur={handleFormSubmit}
            value={med.name}
            onChange={(e) => handleInputChange(index, e.target.value)}
            style={{
              width: '100%',
              padding: '8px 12px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              fontSize: '16px',
              fontFamily: DS.fontBody,
            }}
          />

          {index === 0 && (
            <>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: '#374151',
                  mt: 2,
                  mb: 1,
                  fontFamily: DS.fontBody,
                  fontSize: '16px',
                }}
              >
                Tar du något mer läkemedel utöver ovanstående?
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Box
                  component="label"
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <input
                    type="radio"
                    onBlur={handleFormSubmit}
                    name="addMoreOther"
                    value="Ja"
                    checked={addMoreMode === true}
                    onChange={() => handleAddMoreRadioChange('Ja')}
                    style={{ marginRight: '8px' }}
                  />
                  Ja
                </Box>
                <Box
                  component="label"
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <input
                    type="radio"
                    onBlur={handleFormSubmit}
                    name="addMoreOther"
                    value="Nej"
                    checked={addMoreMode === false}
                    onChange={() => handleAddMoreRadioChange('Nej')}
                    style={{ marginRight: '8px' }}
                  />
                  Nej
                </Box>
              </Box>
            </>
          )}
        </Box>
      ))}

      {addMoreMode === true && (
        <Box
          component="button"
          onClick={handleAddNewSet}
          sx={{
            mt: 2,
            py: 1.5,
            px: 2,
            backgroundColor: DS.deepTeal,
            color: '#FFFFFF',
            borderRadius: '6px',
            width: '100%',
            border: 'none',
            cursor: 'pointer',
            fontFamily: DS.fontBody,
            fontSize: '16px',
          }}
        >
          Lägg till ytterligare läkemedel
        </Box>
      )}
    </Box>
  );
};

export default MultipleOtherMedications;
